const CONDITION_TYPES = [
  {
    id: 'stock-condition-both',
    label: 'All',
    value: undefined,
  },
  {
    id: 'stock-condition-used',
    label: 'Used',
    value: 'used',
  },
  {
    id: 'stock-condition-new',
    label: 'New',
    value: 'new',
  },
];

const currentYear = new Date().getFullYear();
const TEST_RANGE = Array.from({ length: currentYear - 2013 }, (_, index) => 2014 + index);

export { TEST_RANGE, CONDITION_TYPES };
